angular.module('b2cApp.services').factory('Budgets', ['$resource',
    function($resource){
        // note: for CH/BE sites this reqiest is redirected to localized prefixed version, but still works.
        // todo: take this URL from dynamic variable created using route app_b2c.get_project_budgets
        return $resource('/review/form/budgets.json', { }, {
            'query': { isArray: true, params: {siteId: 'siteId'} }
        });
    }]);
